import { useCallback } from 'react';

import { useAxios } from '../axios';
import { GetLotParams, Lot } from './lot.types';

export const useGetLots = () => {
  const [{ data, loading }, axiosFetch] = useAxios<{
    result: { data: Lot[]; count: number };
  }>({
    method: 'GET',
  });

  const getLots = useCallback(
    ({
      filterText = '',
      pageNumber = 1,
      resultSize = 25,
      withSystemUsers = false,
    }: GetLotParams) =>
      axiosFetch({
        url: '/counterparty/lot',
        params: {
          filterText,
          pageNumber,
          resultSize,
          withSystemUsers,
        },
      }),
    [axiosFetch],
  );

  return {
    data: data?.result.data,
    loading,
    getLots,
  };
};
